import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="relative bg-navy-950 text-white overflow-hidden py-24 md:py-32" data-id="element-105">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-900 to-black" data-id="element-106"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/20 blur-[150px] rounded-full" data-id="element-107"></div>

      <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8" data-id="element-108">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-8 leading-tight" data-id="element-109">
          Si vas a lanzar tu primera tienda online,{' '}
          <span className="text-accent" data-id="element-110">
            hazlo con estructura desde el inicio
          </span>
        </h2>

        <p className="text-xl text-slate-300 mb-12 leading-relaxed font-light max-w-3xl mx-auto" data-id="element-111">
          Crear una tienda online no debería ser una apuesta. Si tu pyme ya
          tiene productos, clientes y operación, el canal online puede
          convertirse en una nueva etapa de crecimiento. Pero para que eso
          ocurra, necesitas construirlo con criterio — no como una web más.
        </p>

        <div className="flex flex-col items-center" data-id="element-112">
          <CTAButton variant="primary" className="mb-6 w-full sm:w-auto text-lg px-8 py-5 shadow-glow-lg" action="whatsapp" pixelEvent={{
          event: 'AddToCart',
          content_name: 'CTA Final - WhatsApp BitzenEscala',
          content_category: 'BitzenEscala High Ticket',
          value: 1000000,
          currency: 'CLP'
        }} data-id="element-113">
            Solicitar evaluación estratégica
          </CTAButton>
          <p className="text-slate-400 font-medium text-sm" data-id="element-114">
            Atención inicial por WhatsApp para revisar tu caso y orientarte
            sobre si BitzenEscala™ tiene sentido para tu pyme.
          </p>
        </div>
      </div>
    </section>;
}